module.exports = __webpack_public_path__ + "static/media/person02.5ca453ab.png";